import { useEffect, useState } from 'react';

/**
 * The time now (ms), moving on every `everyMs` while `enabled`, so a relative time on an open page
 * ("Pulled 4m ago") keeps ageing. Read it as `formatRelative(at, Math.max(now, at))` so a time newer than
 * the last tick says "just now", never "in 1m".
 */
export function useNow(everyMs: number, enabled = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return;
    const timer = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(timer);
  }, [everyMs, enabled]);
  return now;
}
